import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const ExploreContext = React.createContext();

export const useExploreContext = () => useContext(ExploreContext);

export function ExploreProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [company, setCompany] = useState({});
  const [exploreSidebar, setExploreSidebar] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/bb46615a-3b08-4466-b370-aaaf3432760a')
      .then(setCategories);
    fetchData.get('https://run.mocky.io/v3/bca40e9e-c0a5-4769-8e19-3b1c1450ddcf').then(setCompany);
    fetchData
      .get('https://run.mocky.io/v3/7668c0dc-4fbc-4826-b135-483f01485987')
      .then(setExploreSidebar);
  }, []);

  const value = useMemo(
    () => ({
      categories,
      company,
      exploreSidebar,
    }),
    [categories, company, exploreSidebar]
  );

  return <ExploreContext.Provider value={value}>{children}</ExploreContext.Provider>;
}
